import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Segment, Header, Message } from "semantic-ui-react";
import TourLayoutWrapper from "../components/TourLayoutWrapper";
import TourNav from "../constants/TourNav";
import FlyerStore from "../stores/FlyerStore";
import ContentLoader from "~/components/element/ContentLoader";
import ModalError from "~/components/element/ModalError";
import TourStore from "~/stores/TourStore";
import CustomDndProvider from "~/components/CustomDndProvider";
import FlyerTemplate from "../components/Flyer/FlyerTemplate";
import FlyerBucket from "../components/Flyer/FlyerBucket";
import FlyerForm from "../components/Flyer/FlyerForm";
import { attachAutoScrollHandler, detachAutoScrollHandler } from "~/utils/DnDAutoScroll";
import SaveButton from "../components/SaveButton";
import StickyMenu from "~/components/StickyMenu";
import ToastMessageStore from "~/stores/ToastMessageStore";
import "../styles/Flyer.less";

@observer
class Flyer extends Component {
  @observable flyerStore = null;

  constructor(props) {
    super(props);
    const { i18n } = props;
    document.title = "Tour - Flyer Edit";
    this.flyerStore = new FlyerStore();
    this.flyerStore.locale = i18n.language;
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidMount() {
    attachAutoScrollHandler();

    const { tourId } = this.props;
    this.flyerStore.load(tourId);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    detachAutoScrollHandler();
  }

  onDragEnd(sourceItem, targetItem) {
    this.flyerStore.onDragEnd(sourceItem, targetItem);
  }

  save() {
    const { t, toastMessageStore } = this.props;

    this.flyerStore.save().then(() => {
      toastMessageStore.addToastMessage(t("changesSaved"), "positive", t("success"));
    });
  }

  render() {
    const { tourId, tourStore, t, tourLayoutContentContainerRef } = this.props;
    const { isLoading, photoSlots, mediaItems, formStore, listingInformation, characterLimit } = this.flyerStore;
    const { model, setProperty, isDirty } = formStore;

    if (isLoading || photoSlots.length === 0) {
      return <ContentLoader />;
    }

    return (
      <CustomDndProvider>
        <div id="flyer">
          <ModalError nestStore={tourStore} />
          <StickyMenu
            contextRef={tourLayoutContentContainerRef}
            headerText={t("clientPanelMisc:flyerEdit")}
            subHeader={
              <Header.Subheader>
                <Link to={`/tours/${tourId}/download#flyer-download`}>{t("clientPanelMisc:downloadFlyer")}</Link>
              </Header.Subheader>
            }
            button={<SaveButton disabled={!isDirty} onClick={() => this.save()} />}
          />

          <Message className="flyer-edit-message-container">
            {t("clientPanelMisc:flyerDownloadMovedTo")}{" "}
            <Link to={`/tours/${tourId}/download#video-download`}>
              <u>{t("clientPanelMisc:downloadCenter")}</u>
            </Link>
            . {t("clientPanelMisc:downloadLinksAppearUnderTitle")}
          </Message>

          <Segment className="flyer-template-segment">
            <FlyerTemplate photoSlots={photoSlots} onDragEnd={this.onDragEnd} useTranslation />
          </Segment>
          <Segment>
            <FlyerBucket mediaItems={mediaItems} onDragEnd={this.onDragEnd} useTranslation />
          </Segment>
          <div className="flyer-description-container">
            <FlyerForm
              description={model.description || ""}
              isDirty={isDirty}
              onDescriptionChange={value => setProperty("description", value)}
              onSave={() => this.save()}
              listingInformation={listingInformation}
              characterLimit={characterLimit}
              useTranslation
              showSaveButton={false}
            />
          </div>
        </div>
      </CustomDndProvider>
    );
  }
}

Flyer.propTypes = {
  tourId: PropTypes.number.isRequired,
  tourStore: PropTypes.instanceOf(TourStore),
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  tourLayoutContentContainerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};

export default withTranslation()(TourLayoutWrapper(Flyer, TourNav.FLYER));
